import { useState, createContext } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [showLoadingGlobal, setShowLoadingGlobal] = useState(true);
  const [ownerData, setOwnerData] = useState(null);
  const [userType, setUserType] = useState("");
  const [userId, setUserId] = useState("");
  const [token, setToken] = useState("");
  const [logout, setLogout] = useState(false);
  const [hasTaskRequest, setHasTaskRequest] = useState(false);
  const [summaryAccounts, setSummaryAccounts] = useState({
    username: "",
    account_type: "normal",
    switchable_users: []
  });
  const [needReload, setNeedReload] = useState(false);

  return (
    <AuthContext.Provider
      value={{
        userId,
        setUserId,
        userType,
        setUserType,
        token,
        setToken,
        logout,
        setLogout,
        showLoadingGlobal,
        setShowLoadingGlobal,
        ownerData,
        setOwnerData,
        hasTaskRequest,
        setHasTaskRequest,
        summaryAccounts,
        setSummaryAccounts,
        needReload,
        setNeedReload
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
